import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import axios from "axios"
 
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Check if user has pro feature. THIS FUNCTION IS CALLED IN THE APP COMPONENT. 
// PASS DOWN THE PRO STATUS TO THE COMPONENTS THAT NEED IT, DO NOT USE THIS FUNCTION IN THE COMPONENTS DIRECTLY.
export async function checkHasProFeature(apiUrl: string, idToken: string): Promise<boolean> {
  try {
    const response = await axios.get(
      `${apiUrl}feature/pro`,
      {
        headers: {
          Authorization: idToken,
        },
        validateStatus: () => true
      }
    );
    
    if (response.status === 200) {
      return response.data.enabled === true;
    }
    return false;
  } catch (error) {
    console.error('Error checking pro feature:', error);
    return false;
  }
}

// Check if user has files feature. THIS FUNCTION IS CALLED IN THE APP COMPONENT. 
// PASS DOWN THE FILES STATUS TO THE COMPONENTS THAT NEED IT, DO NOT USE THIS FUNCTION IN THE COMPONENTS DIRECTLY.
export async function checkHasFilesFeature(apiUrl: string, idToken: string): Promise<boolean> {
  try {
    const response = await axios.get(
      `${apiUrl}feature/files`,
      {
        headers: {
          Authorization: idToken,
        },
        validateStatus: () => true
      }
    );
    
    if (response.status === 200) {
      return response.data.enabled === true;
    }
    return false;
  } catch (error) {
    console.error('Error checking files feature:', error);
    return false;
  }
}

/**
 * Formats a file size in bytes to a human-readable string
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

/**
 * Formats a date string to a more readable format
 */
export function formatDate(dateString: string): string {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}
